import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import noop from 'lodash/noop';
import styles from '../Catalog.scss';
import {isDesktop} from 'src/logic/utils';
import cx from 'classnames';
import Dropdown from 'react-dropdown';
import * as actions from 'src/redux/catalogActions';
import Breadcrumbs from 'src/components/Breadcrumbs/Breadcrumbs';


const linkDashedStyle = {
  textDecoration: 'none',
  borderBottom: '1px dashed black',
  display: 'inline'
};

export function CatalogHeader(props) {
    return (
      <div className={styles.catalog_header}>
        <Breadcrumbs routes={props.routes} params={{brand: props.brand, model: props.model, modification: props.modification}}/>
        <h1>{props.whatIsIt}</h1>
        <div className={styles.back_link}>
          <i className={styles.leftArrow}>&larr; </i>
          <a href="#" className="link" style={linkDashedStyle} onClick={() => window.history.back()}>Вернуться назад</a>
        </div>
      </div>
    );
  }

  export default connect(
    (state) => ({...state.catalogReducer}),
    (dispatch) => ({...bindActionCreators(actions, dispatch)})
  )(CatalogHeader);



/** WEBPACK FOOTER **
 ** ./src/components/Catalog/elements/CatalogHeader.jsx
 **/